import React from "react";
import { Typography, Grid } from "@material-ui/core";
import E_AmountDue from "./view/_amount_due";
import E_BillsButton from "./view/_bill_button";
import E_Bills from "./view/_bills";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  whiteColorFont: {
    color: theme.palette.eWhite?.base,
    fontWeight: "bold",
    padding: "1.9vh 1vw",
  },
}));

export default function E_PostpaidAccountSummary() {
  let classes = useStyle();
  const {t:labels, ready: labelReady} = useTranslation("label-E_POSTPAID_ACCOUNTSUMMARY");

  return (
    <Grid container>
      <Grid item xs={12}>
      {
        labelReady ?
        <Typography className={classes.whiteColorFont} variant="h6" align="center">
        <b>{labels("E_ACCOUNT_SUMMARY")}</b>
        </Typography>
        : <Skeleton />
      }
      </Grid>
      <Grid item xs={12}>
        <E_AmountDue />
      </Grid>
      <Grid item xs={12}>
        <E_BillsButton />
      </Grid>
      <Grid item xs={12}>
        <E_Bills />
      </Grid>
    </Grid>
  );
}
